import * as React from 'react';

import { Select } from 'components';
import { zPositions } from '@/constants';
import { getDefaultContact, isClientContactType } from './utils';
import { useContactState, useContactModalState } from './hooks';

interface ContactTypeSelectProps {
  addBuyerContact?: boolean;
}

const ContactTypeSelect: React.FC<ContactTypeSelectProps> = ({
  addBuyerContact,
}) => {
  const [contactState, updateContactState, , , feedbackSendToSeller] =
    useContactState();
  const [contactModalState] = useContactModalState();

  return (
    <Select
      label="Contact Type"
      required
      value={contactState.type}
      zIndex={zPositions.contactModalComponents}
      onChange={value => {
        const currentType = contactState.type;
        if (
          !feedbackSendToSeller &&
          isClientContactType(currentType) &&
          isClientContactType(value)
        ) {
          updateContactState({
            type: value,
          });
        } else {
          updateContactState(getDefaultContact(value, feedbackSendToSeller));
        }
      }}
      options={[
        { label: 'Seller', value: 'Seller' },
        { label: 'Tenant', value: 'Tenant' },
        { label: 'Landlord/Manager', value: 'Landlord/Manager' },
        { label: 'Agent', value: 'Agent' },
        { label: 'Concierge', value: 'Concierge' },
      ]}
      disabled={
        !!contactState.contactId ||
        contactModalState.isProfile ||
        addBuyerContact
      }
      data-cy="contact-type-select"
    />
  );
};

export default ContactTypeSelect;
